import { render, staticRenderFns } from "./FullReportManagement.vue?vue&type=template&id=79318ce6&scoped=true"
import script from "./FullReportManagement.vue?vue&type=script&lang=js"
export * from "./FullReportManagement.vue?vue&type=script&lang=js"
import style0 from "./FullReportManagement.vue?vue&type=style&index=0&id=79318ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79318ce6",
  null
  
)

export default component.exports